
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/other-services",
      function () {
        return require("private-next-pages/services/other-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/other-services"])
      });
    }
  